import { CDN2 } from '@/helpers/api';
import { TRACKER_ENABLED } from '@/utils/tracker_enabled';
import { setLastPageVisited } from '@helpers/history';
import { isServer } from '@utils/isServer';
import { Layout } from 'antd';
import { observer } from 'mobx-react';
import dynamic from 'next/dynamic';
import NextHead from 'next/head';
import Router from 'next/router';
import React, { useEffect } from 'react';

declare const window: any;

const { Content } = Layout;
const isProdution = process.env.NODE_ENV === 'production' && TRACKER_ENABLED;

const NavBar = dynamic(() => import('@componentsPartner/NavBar'), {
  ssr: true,
});

function FacebookPixel() {
  useEffect(() => {
    import('react-facebook-pixel')
      .then((x) => x.default)
      .then((ReactPixel) => {
        window.ReactPixel = ReactPixel;
        ReactPixel.init('522092471979398');
        ReactPixel.pageView();
        Router.events.on('routeChangeComplete', (url) => {
          ReactPixel.pageView();
          // if (url.indexOf('Confirmed') > 0) {
          //   const split = url.split('/');
          //   ReactPixel.track('Purchase', { code: split[split.length - 1] });
          // }
        });
      });
  });
  return null;
}

export function reportWebVitals(metric: { label: string }) {
  if (metric.label === 'custom') {
    ;
  }
}

const PartnerLayout = ({ children, airports }) => {
  useEffect(() => {
    setLastPageVisited();
  });

  return (
    <Layout>
      <NextHead>
        <meta
          property="og:url"
          content={!isServer ? window.location.toString() : undefined}
          key="url"
        />
        <meta property="og:type" content="website" key="og:type" />
        <meta property="og:title" content="On Air Parking" key="og:title" />
        <meta
          property="og:description"
          content="Affordable Quality Parking"
          key="og:description"
        />
        <meta
          property="og:image"
          content={CDN2() + '/staticmyapp/oglogo-white.png'}
          key="og:image"
        />
      </NextHead>
      {isProdution && <FacebookPixel />}
      <NavBar airports={airports} />
      <Content className="site-layout">{children}</Content>
    </Layout>
  );
};

export default observer(PartnerLayout);
